import type { Mention, MentionData } from './types';
import { Paths } from '@/store/constants';
import { apiInvoke } from '@/store/helpers/load';
import { makePayloadRequestInit } from '@/lib/api';
import type { APIParams } from '@/store/helpers/types';
import type { UserId } from '@/shared/types/user';

export async function loadMentions({
  api,
  auth,
  userId,
  limit,
}: { userId: UserId; limit?: number } & APIParams) {
  const params = new URLSearchParams({ userId });
  if (limit) {
    params.append('limit', limit.toString());
  }

  const path = `${Paths.mentions}?${params.toString()}`;
  const response = await apiInvoke<LoadMentionsResponse>(api, path, auth, {
    method: 'GET',
  });

  const mentions: Mention[] = response.data.map(({ id, ...rest }) => ({
    id,
    data: rest,
  }));

  return mentions;
}

type LoadMentionsResponse = {
  data: Array<
    MentionData & {
      id: string;
    }
  >;
};

type DismissMentionResponse = Mention;

export async function dismissMention({
  api,
  auth,
  id,
}: { id: string } & APIParams) {
  const path = `${Paths.mentions}/dismiss`;
  const payload = {
    id,
  };

  const response = await apiInvoke<DismissMentionResponse>(
    api,
    path,
    auth,
    makePayloadRequestInit(payload, 'POST'),
  );

  return response;
}
